import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpUserEvent,
  HttpResponse,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ApiInterceptorService implements HttpInterceptor {
  constructor() {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const legacyOrgId = this.getLegacyOrgId();

    if (req.url.indexOf('/api') !== 0) {
      const legacyUrl = this.mapLegacyUrl(req.url);
      req = req.clone({
        url: legacyUrl,
        setHeaders: {
          'X-Legacy-Org-Id': legacyOrgId
        }
      });
    } else {
      req = req.clone({
        setHeaders: {
          'X-Legacy-Org-Id': legacyOrgId
        }
      });
    }
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.storeLegacyOrgIdFromResponse(event.body);
        }
      })
    );
  }

  private mapLegacyUrl(url: string) {
    const path = url.indexOf('/') === 0 ? url : '/' + url;

    if (path === '/init') {
      return '/api/survey/legacy/init';
    }

    if (path === '/questions') {
      return '/api/survey/legacy/questions';
    }

    if (path === '/questions/responses') {
      return '/api/survey/legacy/questions/responses';
    }

    if (path === '/questions/locked') {
      return '/api/survey/legacy/questions/locked';
    }

    if (path === '/questions/seen') {
      return '/api/survey/legacy/questions/seen';
    }

    if (path === '/questions/survey-complete') {
      return '/api/survey/legacy/questions/survey-complete';
    }

    if (path === '/results/all') {
      return '/api/survey/legacy/results/all';
    }

    const responseMatch = path.match(/^\/questions\/([^/]+)\/response$/);
    if (responseMatch) {
      return `/api/survey/legacy/questions/${encodeURIComponent(
        responseMatch[1]
      )}/response`;
    }

    if (path === '/auth/request') {
      return '/api/survey/legacy/auth/request';
    }

    if (path === '/auth/login') {
      return '/api/survey/legacy/auth/login';
    }

    return '/api' + path;
  }

  private getLegacyOrgId() {
    const key = 'startup_muster_legacy_org_id';
    try {
      const existing = window.localStorage && window.localStorage.getItem(key);
      if (existing) {
        return existing;
      }

      const created = this.createUuid();
      if (window.localStorage) {
        window.localStorage.setItem(key, created);
      }
      return created;
    } catch (_err) {
      return this.createUuid();
    }
  }

  private storeLegacyOrgIdFromResponse(body: any) {
    if (!body) {
      return;
    }

    const data = body.data || body.result || body;
    const orgId = data && data.orgId;
    if (!orgId || !this.isUuid(orgId)) {
      return;
    }

    try {
      if (window.localStorage) {
        window.localStorage.setItem('startup_muster_legacy_org_id', orgId);
      }
    } catch (_err) {}
  }

  private isUuid(value: string) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      value
    );
  }

  private createUuid() {
    if (
      window.crypto &&
      typeof (window.crypto as any).randomUUID === 'function'
    ) {
      return (window.crypto as any).randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
